
  <div class="intro-text">
      <p>{{'indoor_calendar_intro' | transloco}}</p>
  </div>
  <div class="content-wrapper">
    <app-filters-indoor></app-filters-indoor>
    <app-event-list-indoor class="app-event-list-indoor"></app-event-list-indoor>
  </div>
  <hr class="spacer" />

